/**
 * Wave Config Log Service - 业务逻辑层 + Mock 适配
 * 页面组件只调用此 Service 层,不直接调用 API
 */

import { config } from '../../config';
import * as waveMock from '../../mocks/wave';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import type { ApiResponse, PageData } from '../../types/common';
import type {
  WaveConfigLogDTO,
  QueryWaveConfigLogPageRequest,
} from '../../types/wave/waveConfigLog';

/**
 * 分页查询波次配置日志
 */
export async function pageWaveConfigLogs(
  params: QueryWaveConfigLogPageRequest
): Promise<ApiResponse<PageData<WaveConfigLogDTO>>> {
  if (config.mock) return waveMock.mockPageWaveConfigLogs(params);

  return httpClient.post(API_ENDPOINTS.WAVE_CONFIG_LOG.PAGE, params);
}
